export default {
      id: "separateur-date-agenda-usage",
      viewBox: "0 0 36 10",
      url: "../dist/images/" + "sprite.svg#separateur-date-agenda-usage",
      toString: function () {
        return this.url;
      }
    }